import Phaser from "phaser";

export const DESIGN_WIDTH = 540;
export const DESIGN_HEIGHT = 960;

/**
 * Persistent HUD (run banner + vignette) reserved top inset.
 * Scenes should avoid placing critical UI above this height.
 */
export const HUD_HEIGHT = 150;

export const COLORS = {
  background: 0x0f172a,
  panelFill: 0x14223b,
  panelStroke: 0x2d4a7c,
  buttonFill: 0x1f3257,
  buttonStroke: 0x5ca2ff,
  skillCardFill: 0x1f3e6f,
  skillCardStroke: 0x7dd3fc,
  perkCardFill: 0x1c2d3f,
  perkCardStroke: 0x6ee7b7,
  skillBadgeFill: 0x0ea5e9,
  perkBadgeFill: 0x10b981,
  textPrimary: "#f1f5f9",
  textMuted: "#cbd5e1",
  damageText: "#f87171",
  healText: "#86efac",
  shieldText: "#93c5fd",
};

export const TEXT_STYLES = {
  title: {
    fontFamily: "Arial",
    fontSize: "36px",
    color: COLORS.textPrimary,
  } as Phaser.Types.GameObjects.Text.TextStyle,
  subtitle: {
    fontFamily: "Arial",
    fontSize: "24px",
    color: COLORS.textPrimary,
  } as Phaser.Types.GameObjects.Text.TextStyle,
  body: {
    fontFamily: "Arial",
    fontSize: "20px",
    color: COLORS.textMuted,
  } as Phaser.Types.GameObjects.Text.TextStyle,
  button: {
    fontFamily: "Arial",
    fontSize: "22px",
    color: COLORS.textPrimary,
  } as Phaser.Types.GameObjects.Text.TextStyle,
  combatText: {
    fontFamily: "Arial",
    fontSize: "32px",
    color: COLORS.textPrimary,
  } as Phaser.Types.GameObjects.Text.TextStyle,
};

export const LAYOUT = {
  screenPadding: 24,
  buttonHeight: 64,
  buttonSpacing: 16,
  panelPadding: 12,
};

export const PRIMITIVE_COLORS = {
  // Core palette
  sky: 0x38bdf8,
  blue: 0x3b82f6,
  indigo: 0x6366f1,
  violet: 0x8b5cf6,
  purple: 0xa855f7,
  pink: 0xec4899,
  rose: 0xf43f5e,
  red: 0xef4444,
  orange: 0xf97316,
  amber: 0xf59e0b,
  yellow: 0xeab308,
  lime: 0x84cc16,
  green: 0x22c55e,
  emerald: 0x10b981,
  teal: 0x14b8a6,
  cyan: 0x06b6d4,

  // Grays
  slate: 0x64748b,
  gray: 0x6b7280,
  zinc: 0x71717a,
  neutral: 0x737373,
  stone: 0x78716c,

  // Dark shades
  darkSlate: 0x1e293b,
  darkGray: 0x374151,
  darkZinc: 0x27272a,

  // Light shades
  lightSky: 0x7dd3fc,
  lightBlue: 0x93c5fd,
  lightGreen: 0x86efac,
  lightRed: 0xfca5a5,
  lightYellow: 0xfde047,
  lightPurple: 0xc4b5fd,

  // Semantic aliases
  white: 0xffffff,
  black: 0x000000,
  transparent: 0x000000, // Use with alpha
};
